const CLOUD_FUNCTIONS = process.env.REACT_APP_CLOUD_FUNCTIONS_URL;

const FUNCTIONS_API = {
    USERS: CLOUD_FUNCTIONS + "/api/users/",
    BACKUPS: {
        TRIGGER: CLOUD_FUNCTIONS + "/api/triggerBackup/",
        RESTORE: CLOUD_FUNCTIONS + "/api/restoreBackup/",
    },
    UTILS: {
        RECURSIVE_DELETE: CLOUD_FUNCTIONS + "/api/recursiveDelete/",
    },
};

const MAIN_SITE_GITHUB_REPO = `https://api.github.com/repos/${process.env.REACT_APP_MAIN_SITE_GITHUB_USERNAME}/${process.env.REACT_APP_MAIN_SITE_GITHUB_REPOSITORY_NAME}`;

const GITHUB_API = {
    TRIGGER_REPO_DISPATCH:
        MAIN_SITE_GITHUB_REPO +
        "/actions/workflows/firebase-hosting-merge.yml/dispatches",
    LIST_WORKFLOW_RUNS: MAIN_SITE_GITHUB_REPO + "/actions/runs",
};

export const ENDPOINT = {
    FUNCTIONS_API,
    GITHUB_API,
};
